module.exports = __webpack_public_path__ + "assets/img/banner.112be9d0.jpg";